module.exports = __webpack_public_path__ + "static/elisa-8f4753738d7831263c1195aedb89eec7.svg";